import React, { useEffect, useContext } from "react";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";

import { MainContext } from "./context";
import Header from "../components/Header";
import Footer from "../components/Footer/Footer";
import About from "../pages/AboutRevamp/About";
import Cancel from "../pages/Cancel/Cancel";
import Career from "../pages/Career/Career";
import Cart from "../pages/Cart";
import Checkout from "../pages/Checkout/Checkout";
import Home from "../pages/Home";
import Hoticulture from "../pages/Hoticulture/Hoticulture";
import Orders from "../pages/Orders/Orders";
import PrivacyPolicy from "../pages/Privacy/PrivacyPolicy";
import ProceedCart from "../pages/ProceedCart";
import Terms from "../pages/Terms/Terms";
import GalleryView from "../pages/GalleryView";
// import NotFound from "../pages/NotFound";

export default function MainRouter() {
  const { userData } = useContext(MainContext);
  useEffect(() => {}, [userData]);

  return (
    <HashRouter>
      <Header />
      <Switch>
        <Route exact path="/cart/:cat_id/:var_id/:ser_id" component={Cart} />
        <Route exact path="/proceed" component={ProceedCart} />
        <Route
          exact
          path="/checkout"
          render={() =>
            userData.id ? <Checkout /> : <Redirect to="/proceed" />
          }
        />
        <Route
          exact
          path="/orders"
          render={() => (userData.id ? <Orders /> : <Redirect to="/" />)}
        />
        <Route exact path="/about" component={About} />
        <Route exact path="/careers" component={Career} />
        <Route exact path="/terms&conditions" component={Terms} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/cancellation&refund-policy" component={Cancel} />
        <Route exact path="/upcoming" component={Hoticulture} />
        <Route exact path="/gallery" component={GalleryView} />
        <Route exact path="/:type" component={Home} />
        <Route path="/">
          <Redirect to="/home" />
        </Route>
      </Switch>
      <Footer />
    </HashRouter>
  );
}
